export { default } from './PriceLarge'
